<template>
  <div class="wx-main" :style="{zIndex: alertData.show && alertData.type === 'template' ? 999 : 11}">
    <!-- <img src="https://logo.wondercv.com/banners/cSnaBFEyDNPAQk0.png" alt="" class="wx-phone-img" @click="show = !show"> -->
    <img src="@/assets/image/cvs/wx-icon.svg" alt="" class="wx-phone-img" @click="show = !show">
    <!-- <div class="label">扫码下载</div> -->
    <!-- <div class="wx-hover-main-max" v-show="show" v-if="alertData.show && alertData.type === 'template'" >
      <img src="https://files.wondercv.com/pc/cvs/app-code.png" alt="" width="160">
      <p class="wx-title">下载APP 得海量模板</p>
      <p class="wx-msg">扫码立即下载</p>
    </div> -->
    <!-- <div class="wx-hover-main" v-else> -->
    <div class="wx-hover-main">
      <div class="code">`
        <img src="https://files.wondercv.com/download-code/cv-bottom-right-mobile.png" alt="">
      </div>
<!--      <p class="wx-title">超级简历 APP</p>-->
<!--      <p class="wx-msg">扫码立即下载</p>-->
    </div>

  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'Wx',
  data(){
    return{
      show: true
    }
  },
  computed:{
    ...mapState('app', ['alertData']),
  },


}
</script>
<style lang="scss" scoped>
.wx-main {
  width: 50px;
  position: fixed;
  right: 30px;
  bottom: 158px;
  z-index: 11;
  cursor: pointer;
  .wx-phone-img {
    display: block;
    width: 100%;
    // height: 100%;
    border-radius: 50%;
  }
  // .label{
  //   width: 100%;
  //   color: #fff;
  //   text-align: center;
  //   font-size: 12px;
  //   margin-top: 8px;
  // }
  .wx-hover-main {
    width: 256px;
    height: 300px;
    background: url("https://files.wondercv.com/pc/code/hover_download_background.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);
    margin-left: -20px;
    box-shadow:0 2px 16px 0 rgba(0, 0, 0, .08);
    border-radius: 4px;
    display: none;
    &::after {
      content: "";
      display: block;
      width: 14px;
      height: 14px;
      background: #ff6644;
      transform-origin: 50% 50%;
      transform: rotate(45deg);
      position: absolute;
      top: 50%;
      right: 0;
      margin-right: -6px;
      margin-top: -6px;
    }
    .code {
      width: 180px;
      height: 180px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 38px;
      top: 96px;
      img {
        //display: block;
        width: 160px;
        height: 160px;
        transform: translateX(-3px);
        //margin: 20px auto 0;
      }
    }
    p {
      text-align: center;
    }
    .wx-title {
      font-size: 14px;
      color: #404040;
      margin-top: 17px;
    }
    .wx-msg {
      font-size: 12px;
      color: #9C9C9C;
      margin-top: 10px;
    }
  }
  &:hover {
    .wx-hover-main {
      display: block;
    }
  }
  .wx-hover-main-max {
    width: 248px;
    height: 268px;
    background: #fff;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);
    margin-left: -20px;
    box-shadow:0px 2px 16px 0px rgba(0,0,0,0.08);
    border-radius: 4px;
    &::after {
      content: "";
      display: block;
      width: 14px;
      height: 14px;
      background: #fff;
      transform-origin: 50% 50%;
      transform: rotate(45deg);
      position: absolute;
      top: 50%;
      right: 0;
      margin-right: -6px;
      margin-top: -6px;
    }
    img {
      display: block;
      width: 160px;
      height: 160px;
      margin: 28px auto 0;
    }
    p {
      text-align: center;
    }
    .wx-title {
      font-size: 16px;
      color: #404040;
      margin-top: 16px;
    }
    .wx-msg {
      font-size: 12px;
      color: #9C9C9C;
      margin-top: 12px;
    }
  }
}
</style>